<template>
  <Layout>
    <div class="d-flex forgot-password-container justify-content-center align-items-center">
      <b-card class="forgot-password-box">
        <reset-password-form
          class="mb-3"
          v-model="username" 
          v-if="step == 'request'" 
          @success="gotoStep('change-password')" 
        />

        <change-password-form 
          class="mb-3"
          :username="username"
          v-model="password"
          v-if="step == 'change-password'"
          @success="() => $router.push({ name: 'login', query: { changePassword: 1 }})" 
        />

        <success-password-form 
          class="mb-3"
          v-if="step == 'success'"
          :username="username"
          :password="password"
        />
        <chat-support />
      </b-card>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import ResetPasswordForm from './reset-password-form.vue';
import ChangePasswordForm from './change-password-form.vue';
import SuccessPasswordForm from './success-password-form.vue';

export default {
  props: ['email'],
  data(){
    return {
      step: 'request',
      username: null,
      password: null,
    }
  },
  components: {
    Layout,
    ResetPasswordForm,
    ChangePasswordForm,
    SuccessPasswordForm
  },
  methods: {
    gotoStep(step){
      this.step = step;
    }
  },
  mounted(){
    if(this.email){
      this.username = this.email;
    }
  }
}
</script>

<style>
.forgot-password-box {
  width: 493px;
  border-radius: 8px;
}

.forgot-password-box .card-body {
  padding: 24px;
}

.forgot-password-box label {
  font-weight: 500;
  font-family: 'Poppins';
}

.forgot-password-container {
  height: 80vh;
}

.forgot-password-container h3 {
  font-family: 'Poppins';
}

.red {
  color: #FF0000;
}
</style>